(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("6lp4x", function(module, exports) {
var $49e8271224af325a$var$copyLinkButton = document.querySelector(".share-buttons__copy-link");
if ($49e8271224af325a$var$copyLinkButton !== null) $49e8271224af325a$var$copyLinkButton.addEventListener("click", function() {
    navigator.clipboard.writeText(window.location.href);
});

});

})();
//# sourceMappingURL=share-buttons.1dd2a2f9.js.map
